var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0", outlined: "" } },
    [
      _c("v-data-table", {
        staticStyle: { width: "100%" },
        attrs: {
          "fixed-header": "",
          items: _vm.inboxes,
          "sort-by": ["date"],
          "sort-desc": [true],
          headers: _vm.headers,
          "hide-default-footer": "",
          "disable-pagination": "",
        },
        scopedSlots: _vm._u([
          {
            key: "item.date",
            fn: function ({ item }) {
              return [
                _c("v-card-text", [
                  _vm._v(_vm._s(_vm._f("formatDate")(item.date))),
                ]),
              ]
            },
          },
          {
            key: "item.uid",
            fn: function ({ item }) {
              return [
                _c("v-card-text", [_vm._v(_vm._s(_vm.getUserName(item)))]),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        disabled:
                                          !_vm.ifCanDeleteInboxMessage(),
                                        loading: false,
                                        icon: "",
                                        color: "red",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDelete(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-delete"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Delete from inbox")])]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }